<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...$$restProps}>
	<path
		d="M16.9697 1H13.2209V15.9855C13.2209 17.771 11.7791 19.2377 9.98483 19.2377C8.19056 19.2377 6.74874 17.771 6.74874 15.9855C6.74874 14.2319 8.15852 12.7971 9.88873 12.7333V8.97103C6.07589 9.03477 3 12.1275 3 15.9855C3 19.8754 6.13996 23 10.0169 23C13.8937 23 17.0337 19.8435 17.0337 15.9855V8.30143C18.4435 9.32174 20.1737 9.92754 22 9.95944V6.1971C19.1805 6.10145 16.9697 3.80579 16.9697 1Z"
		fill="currentColor"
	/>
</svg>
